import {
  REPORT_MAX_WINDOW_DAYS,
  criteriaReportParamSchema,
} from '@aica/api-types/schemas';
import {
  parseObjectionsSearch,
  type ObjectionsPeriod,
} from '@/components/analytics/objections/objections-search';

/**
 * Параметры адреса экрана «Отчёт по критериям» (E4, #1342) — всё его
 * состояние: период с опорной датой, проекты и выбранный критерий. Тот же
 * отчёт #866, что вкладка «Критерии» прежних дашбордов, но своим экраном: с
 * единым дашбордом вкладки нет, и карточка «Критерии компании» ведёт сюда.
 *
 * Период, опорная дата и проекты читаются так же, как у «Возражений» и
 * «Соблюдения скрипта»: один разбор на экраны раздела.
 */
export interface CriteriaReportSearch {
  period?: ObjectionsPeriod;
  /** Any instant inside the shown period (ISO). */
  anchor?: string;
  projectIds?: string[];
  /**
   * An exact window, its calendar day and the demo rule the dashboard card was
   * counted by (`ObjectionsSearch`) — the «Отчёт →» link carries the card's
   * own scope.
   */
  from?: string;
  to?: string;
  day?: string;
  demo?: 'yes' | 'no';
  /** The criterion open on the right — by the server's own id rule. */
  criterion?: string;
}

export function parseCriteriaReportSearch(
  search: Record<string, unknown>
): CriteriaReportSearch {
  const { period, anchor, projectIds, from, to, day, demo } =
    // The report routes' limit, not the stream's: the two are separate numbers.
    parseObjectionsSearch(search, REPORT_MAX_WINDOW_DAYS);
  const parsed = criteriaReportParamSchema.shape.criterionId.safeParse(search.criterion);
  return {
    ...(period ? { period } : {}),
    ...(anchor ? { anchor } : {}),
    ...(projectIds ? { projectIds } : {}),
    ...(from && to ? { from, to } : {}),
    ...(day ? { day } : {}),
    ...(demo ? { demo } : {}),
    ...(parsed.success ? { criterion: parsed.data } : {}),
  };
}
